"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Card = _interopRequireDefault(require("@mui/material/Card/Card.js"));
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent/CardContent.js"));
var _CardHeader = _interopRequireDefault(require("@mui/material/CardHeader/CardHeader.js"));
var _Box = _interopRequireDefault(require("@mui/material/Box/Box.js"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton/IconButton.js"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip/Tooltip.js"));
var _Accordion = _interopRequireDefault(require("@mui/material/Accordion/Accordion.js"));
var _AccordionSummary = _interopRequireDefault(require("@mui/material/AccordionSummary/AccordionSummary.js"));
var _AccordionDetails = _interopRequireDefault(require("@mui/material/AccordionDetails/AccordionDetails.js"));
var _List = _interopRequireDefault(require("@mui/material/List/List.js"));
var _ListItemIcon = _interopRequireDefault(require("@mui/material/ListItemIcon/ListItemIcon.js"));
var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText/ListItemText.js"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _ListItemButton = _interopRequireDefault(require("@mui/material/ListItemButton/ListItemButton.js"));
var _CardActions = _interopRequireDefault(require("@mui/material/CardActions/CardActions.js"));
var _Button = _interopRequireDefault(require("@mui/material/Button/Button.js"));
var _Chip = _interopRequireDefault(require("@mui/material/Chip/Chip.js"));
var _announcementTypes = require("../types/announcementTypes");
var _Image = _interopRequireDefault(require("@mui/icons-material/esm/Image.js"));
var _PictureAsPdf = _interopRequireDefault(require("@mui/icons-material/esm/PictureAsPdf.js"));
var _Description = _interopRequireDefault(require("@mui/icons-material/esm/Description.js"));
var _Download = _interopRequireDefault(require("@mui/icons-material/esm/Download.js"));
var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/esm/ExpandMore.js"));
var _VideoLibrarySharp = _interopRequireDefault(require("@mui/icons-material/esm/VideoLibrarySharp.js"));
var _OpenInNew = _interopRequireDefault(require("@mui/icons-material/esm/OpenInNew.js"));
var _ArrowForward = _interopRequireDefault(require("@mui/icons-material/esm/ArrowForward.js"));
var _TextEditorV = _interopRequireDefault(require("./text-editor-v2/TextEditorV2"));
var _announcementUtils = require("../utils/announcementUtils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AnnouncementRender = ({
  announcement,
  showActions = false,
  userId = null,
  userAccessKey,
  getSrcUrlFromAttachmentToken,
  getAttachment,
  scrollable = false,
  sx = {},
  onContinue = () => void {}
}) => {
  const [mediaSrc, setMediaSrc] = (0, _react.useState)(null);
  const [loading, setLoading] = (0, _react.useState)(false);
  const [expanded, setExpanded] = (0, _react.useState)(false);
  const {
    title,
    description,
    attachments,
    startDate: date,
    endDate,
    tags
  } = announcement;
  // Note: For now, hiding the 'Learn More' button.
  const showLearnMore = false;
  const isMaintenanceWithAccess = announcement.mode !== _announcementTypes.AnnouncementAppMode.Platform && announcement.type === 'maintenance' && announcement.whitelistedUserIds?.includes(userId);
  const fileHandlerConfig = {
    getSrcUrlFromToken: getSrcUrlFromAttachmentToken
  };
  const handleDownload = attachment => {
    if (attachment && attachment.token) {
      getAttachment(attachment.token).then(response => {
        const url = URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', attachment.name);
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      });
    }
  };
  const renderIcon = type => {
    if (type.startsWith('image/')) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.default, {});
    }
    if (type.startsWith('video/')) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_VideoLibrarySharp.default, {});
    }
    if (type === 'application/pdf') {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PictureAsPdf.default, {});
    }
    if (type.startsWith('application/vnd.openxmlformats-officedocument.spreadsheetml.')) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Description.default, {});
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Description.default, {});
  };
  const handleAccordionChange = (event, newExpanded) => {
    event.preventDefault();
    setExpanded(newExpanded);
  };
  const handleMoreButtonClick = () => {
    // Logic for redirecting to the Announcements app using announcement ID
    // You can create the URL and use window.location.href or a routing method here
  };
  const handleContinueClick = () => {
    onContinue();
  };
  const formattedDates = (0, _announcementUtils.formatAnnouncementDates)(date, endDate, isMaintenanceWithAccess ? _announcementTypes.SolutionAnnouncementType.Maintenance : _announcementTypes.SolutionAnnouncementType.Feature);
  const obj = scrollable ? {
    minWidth: 300,
    margin: 'auto',
    maxHeight: '70dvh',
    overflowY: 'auto'
  } : {
    minWidth: 300,
    margin: 'auto'
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.default, {
    sx: {
      ...obj,
      ...sx
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CardHeader.default, {
      title: title,
      subheader: formattedDates,
      sx: {
        '.MuiCardHeader-content': {
          textAlign: 'center'
        },
        '.MuiCardHeader-title': {
          fontSize: '2.5rem'
        },
        '.MuiCardHeader-subheader': {
          color: theme => theme.palette.mode === 'dark' ? theme.palette.grey[500] : theme.palette.text.secondary,
          textAlign: 'center'
        }
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CardContent.default, {
      children: [tags && tags.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        sx: {
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          mb: 2
        },
        children: tags.map((tag, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip.default, {
          sx: {
            marginRight: 1
          },
          label: tag.text,
          color: tag.color
        }, index))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextEditorV.default, {
        initialValue: description,
        editable: false,
        userAccessKey: userAccessKey,
        fileHandlerConfig: fileHandlerConfig
      }), attachments && attachments.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Accordion.default, {
        sx: {
          mt: 2
        },
        expanded: expanded,
        onChange: handleAccordionChange,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_AccordionSummary.default, {
          expandIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandMore.default, {
            sx: {
              color: 'text.secondary'
            }
          }),
          "aria-controls": "panel1a-content",
          id: "panel1a-header",
          sx: {
            boxShadow: 3
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
            sx: {
              flexShrink: 0,
              color: 'text.primary',
              fontWeight: 'bold'
            },
            children: "Attachments"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AccordionDetails.default, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.default, {
            children: attachments.map(att => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ListItemButton.default, {
              onClick: () => handleDownload(att),
              sx: {
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.1)'
                },
                borderRadius: 1,
                boxShadow: 3,
                p: 1,
                marginTop: 2
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemIcon.default, {
                sx: {
                  color: 'text.secondary'
                },
                children: renderIcon(att.type)
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText.default, {
                sx: {
                  fontWeight: 'bold',
                  color: 'text.primary'
                },
                primary: att.name
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
                title: "Download",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Download.default, {
                    sx: {
                      color: 'text.secondary'
                    }
                  })
                })
              })]
            }, att.token))
          })
        })]
      })]
    }), showActions && (showLearnMore || isMaintenanceWithAccess) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CardActions.default, {
      sx: {
        padding: 2,
        justifyContent: 'center'
      },
      children: [showLearnMore && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        onClick: handleMoreButtonClick,
        variant: "outlined",
        color: "secondary",
        endIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OpenInNew.default, {}),
        children: "Learn More"
      }), isMaintenanceWithAccess && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        onClick: handleContinueClick,
        variant: "contained",
        endIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArrowForward.default, {}),
        children: "Continue"
      })]
    })]
  });
};
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(AnnouncementRender);